/* eslint-disable max-len */
import React from 'react';

import {
  Typography,
} from '@material-ui/core';
import Layout from './layout';

const styles = {
  subtitle1: {
    marginTop: 68,
    marginBottom: 24,
  },
};
const BacePolicy = ({ children }) => (
  <Layout>
    <Typography paragraph variant="h5">プライバシーポリシー</Typography>
    <Typography paragraph variant="body2">合同会社ふたさじ は、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。</Typography>

    <Typography style={styles.subtitle1} paragraph variant="subtitle1"><strong>個人情報の管理</strong></Typography>
    <Typography paragraph variant="body2">
      お客さまの個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。
    </Typography>

    <Typography style={styles.subtitle1} paragraph variant="subtitle1"><strong>個人情報の利用目的</strong></Typography>
    <Typography paragraph variant="body2">本アプリのサービス提供のため、以下の情報を提供するようにあなたに要求する場合があります</Typography>

    {children}

    <br />
    <Typography paragraph variant="body2">本アプリは、以下の目的でお客様を識別するための情報(アプリ利用情報、広告ID等, 端末情報)を収集する第三者のサービスを利用しています。</Typography>
    <ul>
      <li><Typography paragraph variant="body2">広告表示のため</Typography></li>
      <li><Typography paragraph variant="body2">クラッシュ情報の取得</Typography></li>
      <li><Typography paragraph variant="body2">統計データとして利用状況の分析のため</Typography></li>
    </ul>

    <Typography style={styles.subtitle1} paragraph variant="subtitle1"><strong>第三者サービスのプライバシーポリシー</strong></Typography>
    <Typography paragraph variant="body2">
      本アプリが利用する第三者サービス提供者のプライバシーポリシーへのリンク
    </Typography>
    <ul>
      <li><Typography paragraph variant="body2"><a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">Google Play Services</a></Typography></li>
      <li><Typography paragraph variant="body2"><a href="https://support.google.com/admob/answer/6128543?hl=en" target="_blank" rel="noopener noreferrer">AdMob</a></Typography></li>
      <li><Typography paragraph variant="body2"><a href="https://firebase.google.com/policies/analytics" target="_blank" rel="noopener noreferrer">Google Analytics for Firebase</a></Typography></li>
      <li><Typography paragraph variant="body2"><a href="https://firebase.google.com/support/privacy/" target="_blank" rel="noopener noreferrer">Firebase</a></Typography></li>
    </ul>

    <Typography style={styles.subtitle1} paragraph variant="subtitle1"><strong>個人情報の第三者への開示・提供の禁止</strong></Typography>
    <Typography paragraph variant="body2">お客さまよりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。</Typography>
    <ul>
      <li><Typography paragraph variant="body2">お客さまの同意がある場合</Typography></li>
      <li><Typography paragraph variant="body2">お客さまが希望されるサービスを行なうために業務を委託する業者に対して開示する場合</Typography></li>
      <li><Typography paragraph variant="body2">法令に基づき開示することが必要である場合</Typography></li>
    </ul>

    <Typography style={styles.subtitle1} paragraph variant="subtitle1"><strong>個人情報の安全対策</strong></Typography>
    <Typography paragraph variant="body2">個人情報の正確性及び安全性確保のために、セキュリティに万全の対策を講じています。</Typography>

    <Typography style={styles.subtitle1} paragraph variant="subtitle1"><strong>ご本人の照会</strong></Typography>
    <Typography paragraph variant="body2">お客さまがご本人の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応させていただきます。</Typography>

    <Typography style={styles.subtitle1} paragraph variant="subtitle1"><strong>法令、規範の遵守と見直し</strong></Typography>
    <Typography paragraph variant="body2">保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。</Typography>

    <Typography style={styles.subtitle1} paragraph variant="subtitle1">お問い合せ</Typography>
    <Typography paragraph variant="body2">個人情報の取扱に関するお問い合せは下記までご連絡ください。</Typography>
    <Typography paragraph variant="body2">support@futasaji.net</Typography>
    <br />
    <Typography variant="body2">2021年2月5日　施行</Typography>
  </Layout>
);

export default BacePolicy;
